import { createApi } from '@reduxjs/toolkit/query/react';
import { waServicesQuery } from './baseQueries';
import { RecordResponse } from '../models/ServiceTypes';

// TODO: Set up env variables for api URLs
// Add query api for each role type
// Create different slices for the various types of data these endpoints bring back
// ie LayoutSlice for menu items, UserProfile slice for stuff like name, email, etc
// ^^ careful to not lose logged in user when impersonating though

// example:
// https://service.wealthaccess.com//api/Administrator/users?searchTerm=david%20benskin&page=1&sort%5B0%5D.Property=FullName&sort%5B0%5D.Direction=asc&sort%5B0%5D.Order=0&_=1702013552576

export interface AdvisorGroupModel {
  AdvisorGroupId: number;
  ParentAdvisorGroupId: number | null;
  ParentName: string | null;
  Name: string;
  IsSystem: boolean;
  HasFirmEnabled: boolean;
  NumberOfAdvisors: number;
  SystemGroupId: number;
  SystemGroupName: string;
  IsSystemDisplay: string;
  IsConverted: boolean;
}
export const advisorGroupsApi = createApi({
  reducerPath: 'advisorGroupsApi',
  baseQuery: waServicesQuery,
  endpoints: (builder) => ({
    getAdminAdvisorGroups: builder.query<
      RecordResponse<AdvisorGroupModel>,
      string
    >({
      query: (query) => ({
        url: `/api/Administrator/advisorGroups`,
        method: 'GET',
        params: {
          searchTerm: query,
        },
      }),
    }),
  }),
});

export const { useGetAdminAdvisorGroupsQuery } = advisorGroupsApi;
